module.exports = __webpack_public_path__ + "img/xlsIcon.b18d08a.svg";